import type { Company } from '../@types/Company';
import { isCompanyBrandingComplete } from './branding';

export function useSetupProgress(company: Company | null | undefined, brandingComplete?: boolean) {
  const isBrandingComplete = brandingComplete ?? isCompanyBrandingComplete(company);

  // Group 1: RNIC validations (3 sub-steps)
  const step1Sub = [
    !!company?.setupSteps?.coproValidation,
    !!company?.setupSteps?.addMissingCopros,
    !!company?.setupSteps?.addressValidation,
  ];
  const step1Progress = step1Sub.reduce((a, b) => a + (b ? 1 : 0), 0) / step1Sub.length;

  // Group 2: Transaction qualification
  const step2Progress = !!company?.setupSteps?.transactionQualification ? 1 : 0;

  // Group 3: Image de marque & Rapports (branding required, report PDF optional)
  const step3Progress = isBrandingComplete ? 1 : 0;

  // Group 4: Collaborators + Alerts (2 sub-steps)
  const step4Sub = [
    !!company?.setupSteps?.collaboratorAttribution,
    !!company?.setupSteps?.mailAlertSetup,
  ];
  const step4Progress = step4Sub.reduce((a, b) => a + (b ? 1 : 0), 0) / step4Sub.length;

  // Group 5: Mail configuration (SMTP + referent mapping)
  const step5Progress = !!company?.setupSteps?.mailConfigSetup ? 1 : 0;

  // Group 6: SCI target qualification (À faire card)
  const step6Progress = !!company?.setupSteps?.sciTargetQualification ? 1 : 0;

  // Group 7: General Assembly date qualification (À faire card)
  const step7Progress = !!company?.setupSteps?.agDateQualification ? 1 : 0;

  const groupProgresses = [
    step1Progress,
    step2Progress,
    step3Progress,
    step4Progress,
    step5Progress,
    step6Progress,
    step7Progress,
  ];
  const total = groupProgresses.length;
  const percent = Math.round((groupProgresses.reduce((a, b) => a + b, 0) / total) * 100);
  const completed = groupProgresses.filter(p => p === 1).length;

  return { completed, total, percent };
}

export const getSetupProgress = useSetupProgress;

